import { useEffect } from "react";
import { ILocationState } from "../api/services/types";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthNavigate } from "./useAuthNavigate";
import { showNotification } from "@/common/utils/showNotification";

export enum NotifyType {
  Profile = "profile",
  Niche = "niche",
}

const notificationTitles: Record<NotifyType, string> = {
  [NotifyType.Profile]: "Sign up to follow creators and customise your feeds",
  [NotifyType.Niche]: "Sign up to join niches and customise your feeds",
};

export const useSignUpNotify = (type: NotifyType) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { navigateSignUp } = useAuthNavigate();
  const title = notificationTitles[type];

  useEffect(() => {
    const locationState = location.state as ILocationState | undefined;

    if (locationState?.showSignUpWarning) {
      showNotification({
        title,
        variant: "info",
        actionButton: { title: "Sign Up", onClick: navigateSignUp },
      });

      const state = { ...locationState };
      delete state.showSignUpWarning;
      navigate({ pathname: location.pathname, search: location.search, hash: location.hash }, {
        replace: true,
        state,
      });
    }
  }, [location, navigate, navigateSignUp, title]);
};
